export default {
  '': {
    en: 'Select Role',
    es: 'Selecciona Rol'
  },
  'Arranger': {
    en: 'Arranger',
    es: 'Arreglista'
  },
  // 'Choir': {
  //   en: 'Choir',
  //   es: 'Coro'
  // },
  'Composer': {
    en: 'Composer',
    es: 'Compositor'
  },
  // 'Conductor': {
  //   en: 'Conductor',
  //   es: 'Conductor'
  // },
  'Engineer': {
    en: 'Engineer',
    es: 'Ingeniero'
  },
  'Ensemble': {
    en: 'Ensemble',
    es: 'Ensamble'
  },
  'Lyricist': {
    en: 'Lyricist',
    es: 'Letrista'
  },
  'Mixer': {
    en: 'Mixer',
    es: 'Mezcla'
  },
  // 'Orchestra': {
  //   en: 'Orchestra',
  //   es: 'Orquesta'
  // },
  'Producer': {
    en: 'Producer',
    es: 'Productor'
  },
  'Remixer': {
    en: 'Remixer',
    es: 'Remixer'
  }
  // 'Writer': {
  //   en: 'Writer',
  //   es: 'Escritor'
  // }
}



// WEBPACK FOOTER //
// ./src/data/contributors-roles.js